(function () {
  function hideSkeleton(skeleton) {
    skeleton.classList.add('is-fading');
    skeleton.addEventListener('transitionend', function () {
      skeleton.hidden = true;
    }, { once: true });
  }

  function initSkeleton(skeleton) {
    var parent = skeleton.parentElement;
    if (!parent) return;

    // Find the first meaningful image in the same wrapper
    var img = parent.querySelector('img.product-card__image--primary')
           || parent.querySelector('img.sale-main-image')
           || parent.querySelector('img');

    if (!img) {
      skeleton.hidden = true;
      return;
    }

    if (img.complete && img.naturalWidth > 0) {
      skeleton.hidden = true;
      return;
    }

    img.addEventListener('load', function () { hideSkeleton(skeleton); }, { once: true });
    img.addEventListener('error', function () { hideSkeleton(skeleton); }, { once: true });
  }

  function initAll() {
    document.querySelectorAll('.product-img-skeleton').forEach(initSkeleton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Handle dynamically injected cards (carousels, quick-buy, etc.)
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        var skeletons = node.classList && node.classList.contains('product-img-skeleton')
          ? [node]
          : Array.from(node.querySelectorAll('.product-img-skeleton'));
        skeletons.forEach(initSkeleton);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
